import { URL_ACCOUNT_SELECT } from '@seek/adv-constants';
import { useHirerAuth } from '@seek/hirer-auth-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useAccountInfo } from 'src/modules/dataManager';
import { getLogger } from 'src/modules/logger';
import type { PageRouteProps } from 'src/types';

export const AuthenticatedPageRoute = ({ children }: PageRouteProps) => {
  const { authenticated, loading: authLoading, login } = useHirerAuth();
  const { pathname, search } = useLocation();
  const {
    advertiser,
    error,
    loading: accountContextLoading,
  } = useAccountInfo();

  useEffect(() => {
    if (!accountContextLoading && !authLoading) {
      if (error || !authenticated) {
        const { logWarn } = getLogger();
        logWarn('Hirer Auth Required', {
          note: `User not logged in. Login required for page: ${pathname}. Redirecting.`,
        });
        login({
          location: {
            origin: '',
            pathname,
            search,
          },
        });
      }
      if (!advertiser) {
        const redirectUri = `${URL_ACCOUNT_SELECT}?returnUrl=${encodeURIComponent(
          pathname + search,
        )}`;

        location.replace(redirectUri);
      }
    }
  }, [
    accountContextLoading,
    advertiser,
    authLoading,
    authenticated,
    error,
    login,
    pathname,
    search,
  ]);

  return children;
};
